/** Bridge between the Arsenal scene (DOM) and the HexField particle engine.
 *  `word` = index of the active skill word the particles should forge (-1 = none). */
export const arsenalStore = {
  word: -1,
}
